<script>
    import ProjectAddressesMap from '../../../shared/components/Addresses/AddressesMap';

    export default {
        extends: ProjectAddressesMap,

        props: {
            selectedStatus: {
                type: String,
                default: 'all',
            },
            sidebarVisible: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            goToAddress() {
                window.location = route(
                    'admin.sales-projects.addresses.show', [
                        this.project,
                        this.selectedAddress.id,
                    ],
                );
            },
        },
    };
</script>